import { Components, Theme } from '@mui/material'

export const MuiPaper: Components<Omit<Theme, 'components'>>['MuiPaper'] = {
  defaultProps: {
    variant: 'outlined',
  },
  styleOverrides: {
    outlined: ({ theme }) => ({
      border: `1px solid ${theme.palette.neutralLight[300]}`,
    }),
    rounded: {
      borderRadius: 8,
    },
  },
}
